<template>
  <section>
    <v-row no-gutters>
      <v-img
        :height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
        src="@/assets/hero-bg.jpg"
      >
        <v-theme-provider dark>
          <v-container fill-height>
            <v-row align="center" justify="center">
              <v-col align="center" class="white--text" cols="12" tag="h1">
                <span
                  class="font-weight-light"
                  :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                >WELCOME TO</span>
                <br />
                <v-img src="@/assets/GroupBot-Logo-Dark.png" contain max-height="150"></v-img>
                <span
                  :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                  class="font-weight-black"
                >{{appName.toUpperCase()}}</span>
                <br />
                <span
                  class="font-weight-light"
                  :class="[$vuetify.breakpoint.smAndDown ? 'subtitle-1' : 'title']"
                >LET'S HELP YOU CONNECT THE WORLD</span>
              </v-col>

              <v-btn class="align-self-end" fab outlined @click="$vuetify.goTo('#about')">
                <v-icon>mdi-chevron-double-down</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </v-theme-provider>
      </v-img>
    </v-row>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapState("app", ["appName"])
  }
};
</script>